var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"avatar",style:({
    'background-image': ("url(https://steemitimages.com/u/" + _vm.username + "/avatar/small"),
    width: ((this.size) + "px"),
    height: ((this.size) + "px"),
  })})}
var staticRenderFns = []

export { render, staticRenderFns }